export default function ColumnLegend() {
  return (
    <div className="c-tax-harvesting-legend">
      <div className="c-tax-harvesting-legend__item">
        <span className="c-tax-harvesting-legend__swatch is-blue" />
        <span className="c-tax-harvesting-legend__label">
          Cálculo tax / harvesting
        </span>
      </div>
      <div className="c-tax-harvesting-legend__item">
        <span className="c-tax-harvesting-legend__swatch is-yellow" />
        <span className="c-tax-harvesting-legend__label">
          Base MXN (Banxico FIX · UDI)
        </span>
      </div>
    </div>
  );
}
